import React from 'react';
import styles from './styles.module.scss';
const DetailsBlock = (props) => {
    return (
        <div className={`${styles.detailBlock}`}>
            <img
                src={`${props.icon}`}
                width={props.imgWidth ? props.imgWidth : '67px'}
                height={props.imgHeight ? props.imgHeight : '67px'}
                alt="image"
            />
            {props.title ? (
                <p className={`${styles.title}`}>{props.title}</p>
            ) : null}
            <p className={`${styles.description}`}>{props.description}</p>
        </div>
    );
};

export default DetailsBlock;
